// extracted by mini-css-extract-plugin
export default {"carouselSection":"Recommendations_carouselSection__Lya-T"};